import React from 'react';
type SectionLabelProps = {
  children: React.ReactNode;
  tone?: 'light' | 'dark';
};
export function SectionLabel({
  children,
  tone = 'light'
}: SectionLabelProps) {
  const toneClass = tone === 'dark' ? 'bg-white/10 text-white/80' : 'bg-ink/[0.06] text-ink/75';
  return <span className={`inline-flex items-center gap-2 rounded-md px-3 py-1.5 text-sm ${toneClass}`} data-id="element-416" data-mp="17q7s0xtezd81">
      <span className="h-1.5 w-1.5 rounded-full bg-brass" aria-hidden="true" data-id="element-417" data-mp="12r4ojht31f26" />
      {children}
    </span>;
}